import { NetFetch } from '../Net/NetFetch';
import { UnauthorizedError } from './Error/UnauthorizedError';
import { StatusCodes } from './Status/StatusCodes';
/**
 * Sightings
 */
export class Sightings {
    /**
     * getList
     */
    static async getList(filter) {
        let data = {};
        if (filter) {
            data = filter;
        }
        const result = await NetFetch.postData('/json/sightings/list', data);
        if (result && result.statusCode) {
            switch (result.statusCode) {
                case StatusCodes.OK:
                    return result;
                case StatusCodes.UNAUTHORIZED:
                    throw new UnauthorizedError();
            }
        }
        return null;
    }
    /**
     * save
     * @param sighting
     */
    static async save(sighting) {
        const result = await NetFetch.postData('/json/sightings/save', sighting);
        if (result && result.statusCode) {
            switch (result.statusCode) {
                case StatusCodes.OK:
                    return true;
                case StatusCodes.UNAUTHORIZED:
                    throw new UnauthorizedError();
            }
        }
        return false;
    }
    /**
     * delete
     * @param sighting
     */
    static async delete(sighting) {
        const result = await NetFetch.postData('/json/sightings/delete', sighting);
        if (result && result.statusCode) {
            switch (result.statusCode) {
                case StatusCodes.OK:
                    return true;
                case StatusCodes.UNAUTHORIZED:
                    throw new UnauthorizedError();
            }
        }
        return false;
    }
    /**
     * setDateByGPS
     */
    static async setDateByGPS() {
        const result = await NetFetch.getData('/json/sightings/setdatebygps');
        if (result && result.statusCode) {
            switch (result.statusCode) {
                case StatusCodes.OK:
                    return result.data;
                case StatusCodes.UNAUTHORIZED:
                    throw new UnauthorizedError();
            }
        }
        return null;
    }
    static async getWeather(sighting) {
        const result = await NetFetch.postData('/json/sightings/weather', sighting);
        console.log(result);
    }
    /**
     * Distinct calendar years (DESC) covered by non-deleted sightings.
     * Returns an empty array on any non-OK response (UNAUTHORIZED still throws).
     */
    static async getYears() {
        var _a;
        const result = await NetFetch.getData('/json/sightings/years');
        if (result && result.statusCode) {
            switch (result.statusCode) {
                case StatusCodes.OK:
                    return (_a = result.years) !== null && _a !== void 0 ? _a : [];
                case StatusCodes.UNAUTHORIZED:
                    throw new UnauthorizedError();
            }
        }
        return [];
    }
}
